import { useEffect, useState } from 'react'
import { fetchScratchCatalog } from '../services/scratchLotteryService'

/**
 * แสดงทางเข้าหวยขูดเมกาเมื่อ platform เปิด + มีอย่างน้อย 1 ชุดเปิดขาย/มีใบเหลือ
 */
export function useScratchLotteryUserEntry(scratchLotteryEnabled?: boolean) {
  const [userEntryVisible, setUserEntryVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    let cancelled = false

    void (async () => {
      if (scratchLotteryEnabled !== true) {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
        return
      }

      try {
        const res = await fetchScratchCatalog()
        const open =
          res.data?.userEntryVisible !== false &&
          (res.data?.items || []).some((item) => item.salesOpen && Number(item.ticketPrice) > 0)
        if (!cancelled) {
          setUserEntryVisible(open)
          setChecked(true)
        }
      } catch {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [scratchLotteryEnabled])

  return {
    showScratchLotteryEntry: scratchLotteryEnabled === true && userEntryVisible,
    checked,
  }
}
